// import { CircleAlert, Loader2 } from 'lucide-react';
// import { useCallback, useEffect, useRef, useState } from 'react';
// import { useTranslation } from 'react-i18next';
// import WaIcon from '@/assets/smartcity/icon-wa.svg';
// import { cn } from '@/lib/utils';
// import { useColorStore } from '@/store/colorStore';

// interface ButtonWhatsappProps {
//   label: string;
//   img?: string;
//   onclick?: () => void;
//   styleButton?: string;
//   disabled?: boolean;
//   loading?: boolean;
//   styleText?: string;
//   tooltip?: boolean;
// }

// const TOOLTIP_WIDTH = 300;
// const TOOLTIP_HEIGHT = 64;
// const TOOLTIP_GAP = 8;
// const VIEWPORT_MARGIN = 8;

// const ButtonWhatsapp = ({
//   img = WaIcon,
//   onclick,
//   label,
//   styleButton,
//   tooltip = false,
//   disabled = false,
//   loading = false,
//   styleText,
// }: ButtonWhatsappProps) => {
//   const { t } = useTranslation();
//   const { NEWCOLOR } = useColorStore();
//   const triggerRef = useRef<HTMLSpanElement>(null);
//   const [tooltipPos, setTooltipPos] = useState<{ top: number; left: number } | null>(null);

//   const showTooltip = useCallback(() => {
//     const rect = triggerRef.current?.getBoundingClientRect();
//     if (!rect) return;

//     let left = rect.left + rect.width / 2 - TOOLTIP_WIDTH / 2;
//     left = Math.max(
//       VIEWPORT_MARGIN,
//       Math.min(left, window.innerWidth - TOOLTIP_WIDTH - VIEWPORT_MARGIN)
//     );

//     let top = rect.bottom + TOOLTIP_GAP;
//     if (top + TOOLTIP_HEIGHT + VIEWPORT_MARGIN > window.innerHeight) {
//       top = rect.top - TOOLTIP_GAP - TOOLTIP_HEIGHT;
//     }
//     top = Math.max(VIEWPORT_MARGIN, top);

//     setTooltipPos({ top, left });
//   }, []);

//   const hideTooltip = useCallback(() => setTooltipPos(null), []);

//   useEffect(() => {
//     if (!tooltipPos) return;
//     window.addEventListener('scroll', hideTooltip, true);
//     window.addEventListener('resize', hideTooltip);
//     return () => {
//       window.removeEventListener('scroll', hideTooltip, true);
//       window.removeEventListener('resize', hideTooltip);
//     };
//   }, [tooltipPos, hideTooltip]);

//   return (
//     <button
//       style={{
//         borderColor: NEWCOLOR.greenPrimary,
//       }}
//       onClick={onclick}
//       disabled={disabled || loading}
//       className={cn(
//         'border relative w-fit cursor-pointer bg-[#00C4831A] inline-flex gap-1 px-2 py-1 rounded-full items-center disabled:opacity-50 disabled:cursor-not-allowed',
//         styleButton
//       )}
//       type="button"
//     >
//       {loading ? <Loader2 size={16} className="animate-spin" /> : <img src={img} alt="whatsapp" />}
//       <span className={cn('uppercase title2', styleText)}>{label}</span>
//       {tooltip && (
//         <span
//           ref={triggerRef}
//           role="img"
//           aria-label="Open Maps from Location Copy and Paste coordinates here."
//           className="inline-flex items-center"
//           onMouseEnter={showTooltip}
//           onMouseLeave={hideTooltip}
//         >
//           <CircleAlert size={20} className="text-text-blue-100" />

//           {tooltipPos && (
//             <div
//               role="tooltip"
//               style={{ top: tooltipPos.top, left: tooltipPos.left, width: TOOLTIP_WIDTH }}
//               className="fixed p-2 bg-text-blue-50 text-xs rounded-md shadow-md z-[9999] pointer-events-none whitespace-normal text-left"
//             >
//               <span className="title2 dark:text-black">{t('cmn > tooltip info')}</span>
//             </div>
//           )}
//         </span>
//       )}
//     </button>
//   );
// };

// export default ButtonWhatsapp;

import { CircleAlert, Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import WaIcon from '@/assets/smartcity/icon-wa.svg';
import { cn } from '@/lib/utils';
import { useColorStore } from '@/store/colorStore';

interface ButtonWhatsappProps {
  label: string;
  img?: string;
  onclick?: () => void;
  styleButton?: string;
  disabled?: boolean;
  loading?: boolean;
  styleText?: string;
  tooltip?: boolean;
}

const ButtonWhatsapp = ({
  img = WaIcon,
  onclick,
  label,
  styleButton,
  tooltip = false,
  disabled = false,
  loading = false,
  styleText,
}: ButtonWhatsappProps) => {
  const { t } = useTranslation();
  const { NEWCOLOR } = useColorStore();

  return (
    <button
      style={{
        borderColor: NEWCOLOR.greenPrimary,
      }}
      onClick={onclick}
      disabled={disabled || loading}
      className={cn(
        'border relative w-fit cursor-pointer bg-[#00C4831A] inline-flex gap-1 px-2 py-1 rounded-full items-center disabled:opacity-50 disabled:cursor-not-allowed',
        styleButton
      )}
      type="button"
    >
      {loading ? <Loader2 size={16} className="animate-spin" /> : <img src={img} alt="whatsapp" />}

      <span className={cn('uppercase title2', styleText)}>{label}</span>

      {tooltip && (
        <span
          role="img"
          aria-label="Open Maps from Location Copy and Paste coordinates here."
          className="relative group inline-flex items-center"
        >
          <CircleAlert size={20} className="text-text-blue-100 cursor-help" />

          <div
            role="tooltip"
            className="
              absolute
              right-0
              top-[calc(100%+8px)]
              w-[300px]
              p-2
              bg-text-blue-50
              text-xs
              rounded-md
              shadow-md
              z-[9999]
              pointer-events-none
              whitespace-normal
              text-left
              opacity-0
              invisible
              group-hover:opacity-100
              group-hover:visible
              transition-opacity
              duration-150
            "
          >
            <span className="title2 dark:text-black">{t('cmn > tooltip info')}</span>
          </div>
        </span>
      )}
    </button>
  );
};

export default ButtonWhatsapp;
